import { useDispatch } from 'react-redux';
import { Button } from 'src/components/atoms';
import { StyledIconInButton } from 'src/components/foundations/foundations.styles';
import { updateCurrentEvent } from 'src/creators/MCC.creators';
import { initialEventState } from 'src/reducers/ManualCase';
import { AppDispatch } from 'src/store';
import { Container, Text } from './DraftEventsEmpty.styles';

interface Props {
  setIsAddingEvent: (isAddingEvent: boolean) => void;
  setIsEditingEvent: (isEditingEvent: boolean) => void;
  disabled?: boolean; // TODO: REMOVE this prop when re-enabling events
}

export const DraftEventsEmpty = ({
  setIsAddingEvent,
  setIsEditingEvent,
  disabled = false, // TODO: REMOVE this prop when re-enabling events
}: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  return (
    <Container>
      <Text>Currently you have no events in your report.</Text>
      <Text bottom>Click to add an event</Text>
      <Button
        data-testid="add-event"
        onClick={() => {
          dispatch(updateCurrentEvent(initialEventState));
          setIsEditingEvent(false);
          setIsAddingEvent(true);
        }}
        variant="primary"
        size="small"
        width="120px"
        disabled={disabled} // TODO: REMOVE this disabled prop when re-enabling events
      >
        <StyledIconInButton
          size="small"
          position="left"
          className="uil uil-plus"
        />
        Add event
      </Button>
    </Container>
  );
};
